























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({name: 'FormulaBar'})
export default class FormulaBar extends Vue {
  public active = false;

  @Prop()
  public value!: string;

  @Prop()
  public label!: string;

  get formula() {
    return this.value;
  }

  set formula(newFormula: string) {
    this.$emit('input', newFormula);
  }
}
